import { useState } from 'react';
import { useNotification } from './useNotification';
import apiService from '../services/api';

const useDoctorsCrud = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { showNotification } = useNotification();

  const addDoctor = async (doctorData) => {
    setIsLoading(true);
    try {
      console.log('Ajout du médecin:', doctorData);
      
      // Appel API réel
      const response = await apiService.createDoctor(doctorData);
      
      console.log('Réponse API:', response);
      showNotification('Médecin ajouté avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de l\'ajout du médecin:', error);
      showNotification(`Erreur lors de l'ajout du médecin: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const updateDoctor = async (doctorId, doctorData) => {
    setIsLoading(true);
    try {
      console.log('Mise à jour du médecin:', doctorId, doctorData);
      
      // Appel API réel
      const response = await apiService.updateDoctor(doctorId, doctorData);
      
      console.log('Réponse API:', response);
      showNotification('Médecin modifié avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la modification du médecin:', error);
      showNotification(`Erreur lors de la modification du médecin: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const deleteDoctor = async (doctorId) => {
    setIsLoading(true);
    try {
      console.log('Suppression du médecin:', doctorId);
      
      // Appel API réel
      const response = await apiService.deleteDoctor(doctorId);
      
      console.log('Réponse API:', response);
      showNotification('Médecin supprimé avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la suppression du médecin:', error);
      showNotification(`Erreur lors de la suppression du médecin: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addDoctor,
    updateDoctor,
    deleteDoctor,
    isLoading
  };
};

export default useDoctorsCrud;
